/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import litigationCaseTranslations from "./litigationCaseTranslations";
import { prosecutionTranslations } from "./prosecutionTranslations";

const generalCivilLawTranslations = {
  label: "Allgemeines Zivilrecht",
  ...litigationCaseTranslations,
  responsibleProsecution: prosecutionTranslations,
  affectedPartyType: {
    label: "Betroffener laut Mandantschaft",
    values: {
      customer: "Er selbst",
      coinsured: "Mitversicherter",
      unknown: "Unbekannt",
    },
  },
  objectivesClient: {
    label: "Zielsetzungen",
    values: {
      payment: "Zahlung",
      injunction: "Unterlassung",
      removal: "Beseitigung",
      handover: "Herausgabe",
      other: "Etwas anderes",
    },
  },
  incidentAddress: {
    streetAddress: {
      label: "Straße und Hausnummer - Vorfall",
    },
    postalCode: {
      label: "PLZ - Vorfall",
    },
    addressLocality: {
      label: "Ort - Vorfall",
    },
  },
  incidentLocalityDescription: {
    label: "Ort des Vorfalls",
  },
  incidentDate: {
    label: "Datum des Vorfalls",
  },
  incidentFrequency: {
    label: "Häufigkeit des Vorfalls",
    values: {
      once: "einmalig",
      multiple: "mehrfach",
    },
  },
};

export default generalCivilLawTranslations;
